<div class="add-utility-root">
  <div class="ac-header">
    <button (click)="save()" class="btn btn-primary" [ngClass]="saveDisabled ? 'btn btn-disabled' : ''">
      Save
    </button>
    <button class="btn btn-cancel" (click)="cancelClicked()">Cancel</button>
  </div>
  <div class="ac-body section-line" [ngClass]="
      activeCard === 5
        ? 'section-line-last-active'
        : activeCard === 6
        ? 'section-line-finished'
        : ''
    ">
    <form ngNativeValidate id="card1Form" (submit)="continue()" class="card-1"
      [ngClass]="activeCard > 1 ? 'item-line' : ''">
      <div class="card-header">
        <div class="num" [ngClass]="activeCard > 1 ? 'card-number-done' : ''">
          1
        </div>
        <div>Utility information</div>
        <div *ngIf="activeCard > 1" (click)="setActiveCard(1)">Edit</div>
      </div>
      <div *ngIf="activeCard === 1">
        <div class="container card form-wrapper">
          <div class="row">
            <div class="col-6 form-item form-floating mb-3">
              <input [(ngModel)]="name" name="name" type="text" class="form-control" id="floatingInput2" placeholder=" "
                required>
              <label for="floatingInput2">Name</label>
            </div>
            <div class="col-6 form-item form-floating mb-3">
              <input [(ngModel)]="acronym" name="acronym" type="text" class="form-control" id="floatingInput3" placeholder=" "
                maxlength="10" required pattern="^[a-zA-Z0-9]*$" (ngModelChange)="onAcronymChange($event)" (keypress)="allowOnlyAlphaNumeric($event)">
              <label for="floatingInput3">Acronym</label>
            </div>
          </div>
          <label class="logo-label">Utility logo</label>
          <div *ngIf="!hasImage; else image" class="drag-drop col-12" appDragAndDrop
            (fileDropped)="onFileDropped($event)">
            <input type="file" id="fileDropRef" name="utilityImage" #utilityImage
              accept="image/png, image/jpg, image/jpeg" (change)="fileBrowserHandler($event)" />
            <div class="upload-img">
              <img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow"/>
            </div>
            <label for="fileDropRef">Drag and drop file here or <span class="browse">Browse</span> to upload</label>

          </div>
          <ng-template #image>
            <div class="pb-4">
              <img style="max-width: 100%;" src="{{ blobUrl || imageSrc }}" alt="Uploaded image"/>
              <span (click)="removeImage()">x</span>
            </div>
          </ng-template>
          <div class="row">
            <div class="col-6 form-item form-floating mb-3">
              <input id="color-test" type="color" [(ngModel)]="color" name="floatingInput2" class="input-color" />
              <input name="color" [(ngModel)]="color" cpOutputFormat="hex" class="form-control" id="floatingInput2"
                placeholder=" " readonly>
              <label *ngIf="color===''" for="floatingInput2">Color code</label>
              <label *ngIf="color!=''" for="floatingInput2">{{color}}</label>
  
            </div>
            <select  name="currency-select" (change)="selectCurrency($event)"class="col-6 form-item">
            <option value="" [selected]="!currency" disabled>Currency</option>
            <option [selected]="currency == c.code" *ngFor="let c of currencyList" value="{{ c.code }}">
              {{ c.text }}
            </option>
          </select>
          </div>
          
          <div class="row">
            <div class="col-6 form-item form-floating mb-3">
              <select  [ngClass]="country !== '' ? 'selected-option' : ''" name="country-select" (change)="selectCountry($event)" required class="form-select">
                <option value="" [selected]="!country" disabled>Country</option>
                <option [selected]="country == c.code" *ngFor="let c of countryList" value="{{ c.code }}">
                  {{ c.text }}
                </option>
              </select>
              <label *ngIf="country !== ''" class="label-for-select" for="floatingSelect">Country</label>
              <div *ngIf="country !== ''" class="select-title"></div>
            </div>        
            <div class="col-6 form-item form-floating mb-3">
              <select [ngClass]="language !== '' ? 'selected-option' : ''" name="language-select" (change)="selectLanguage($event)" required class="form-select">
                <option value="" [selected]="!language" disabled>Language</option>
                <option [selected]="language == c.text" *ngFor="let c of languageList" value="{{ c.text }}">
                  {{ c.text }}
                </option>
              </select>
              <label *ngIf="language !== ''" class="label-for-select" for="floatingSelect">Language</label>
              <div *ngIf="language !== ''" class="select-title"></div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 form-item form-floating mb-3">
              <select
                class="form-select"
                name="utility-select"
                [ngClass]="selectedUtilityId ? 'selected-option' : ''"
                (change)="selectUtility($event)"
              >
                <option value="" [selected]="!selectedUtilityId">
                    Choose a utility to copy configuration from
                </option>
                <option
                  *ngFor="let u of utilityList"
                  [value]="u.key"
                  [selected]="selectedUtilityId == u.key"
                >
                  {{ u.value }}
                </option>
              </select>
              <label *ngIf="selectedUtilityId" class="label-for-select" for="utility-select">
                Utility
              </label>
              <div *ngIf="selectedUtilityId" class="select-title"></div>
            </div> 
          </div>
          <div class="row">
            <span class="mt-4 max-label">Limit maximum selected districts for mobile users</span>
            <div class="btn-group mt-4 col-6">
              <button type="button" class="btn" [class.btn-primary]="!isSelectedAreasForMobileLimited"
                [class.btn-outline-primary]="isSelectedAreasForMobileLimited" (click)="isSelectedAreasForMobileLimited = false">
                Unlimited
              </button>
          
              <button type="button" class="btn" [class.btn-primary]="isSelectedAreasForMobileLimited"
                [class.btn-outline-primary]="!isSelectedAreasForMobileLimited" (click)="isSelectedAreasForMobileLimited = true">
                Limited
              </button>
            </div>
            <div class="mt-4 col-6" *ngIf="isSelectedAreasForMobileLimited">
              <input type="number" class="form-control limit-input" name="maximumSelectedAreasForMobile"
                [(ngModel)]="maximumSelectedAreasForMobile" (blur)="validateLimit()" min="1" placeholder="Enter limit" />
            </div>
          </div>

        </div>
        <div class="btn-continue-container col-6">
          <button class="btn btn-continue" form="card1Form">Continue</button>
        </div>
      </div>
      <div *ngIf="activeCard > 1" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="col-4">Name: {{name}}</div>
            <div class="col-4">Color code: {{color}}</div>
            <div class="col-4">Currency: {{currency}}</div>
          </div>
        </div>
      </div>
    </form>
    <div class="card-4 item" [ngClass]="activeCard > 2 ? 'item-line' : ''">
      <div class="card-header">
        <div class="num" [ngClass]="
            activeCard < 2
              ? 'card-number-gray'
              : activeCard > 2
              ? 'card-number-done'
              : ''
          ">2</div>
        <div [ngClass]="activeCard < 2 ? 'title-gray' : ''">
          Dashboard Configuration
        </div>
        <div *ngIf="activeCard > 2" (click)="setActiveCard(2)">Edit</div>

      </div>
      <div *ngIf="activeCard === 2" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="col-6">
              <span class="col-title">Asset</span>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.AIDroneMap])"
                      (change)="onChange([Configuration.AIDroneMap], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">AI UAV</label>
                </div>
              </div>              
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.Feeders])"
                      (change)="onChange([Configuration.Feeders], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Feeders(33KV,11KV)</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.DTs])"
                      (change)="onChange([Configuration.DTs], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Distribution Substation</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.Poles])"
                      (change)="onChange([Configuration.Poles], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">LT Poles</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.Buildings])"
                      (change)="onChange([Configuration.Buildings], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Buildings</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.Meters])"
                      (change)="onChange([Configuration.Meters], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Meters</label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <span class="col-title">Operations</span>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.Survey])"
                      (change)="onChange([Configuration.Survey], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Survey</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.Installation])"
                      (change)="onChange([Configuration.Installation], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Installation</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.OnlineMeterNumberScan])"
                      (change)="onChange([Configuration.OnlineMeterNumberScan], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Online Meter Number Scan</label>
                </div>
              </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.WorkOrder])"
                      (change)="onChange([Configuration.WorkOrder], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Work order</label>
                </div>
              </div>
                    <div class="headerComponent">
              <div>
                <label class="switch">
                  <input   type="checkbox" [checked]="isChecked([Configuration.CustomerInformationEdit])"
                    (change)="onChange([Configuration.CustomerInformationEdit], $event)" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div>
                <label class="title">Customer Information Edit </label>
              </div>
            </div>
              <div class="headerComponent">
                <div>
                  <label class="switch">
                    <input type="checkbox" [checked]="isChecked([Configuration.StandaloneBillingIntegration])"
                      (change)="onChange([Configuration.StandaloneBillingIntegration], $event);">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div>
                  <label class="title">Billing Integration</label>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <span class="col-title">Map configuration</span>

            <div class="map-config">
              <div class="config-item">
                <span class="icon">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 
                    2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 
                    3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 
                    2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 
                    7 6.602c0 3.455-2.563 7.543-7 
                    14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 
                    0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 
                    16.398 4.531-7.188 8-12.2 8-16.398 
                    0-4.199-3.801-7.602-8-7.602"/>
                  </svg>
                </span>
                <span class="config-text">{{ mapConfiguration?.latitude | hasValue }}, {{ mapConfiguration?.longitude | hasValue }}</span>
              </div>

              <div class="config-item">
                <span class="icon">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="m15.97 17.031c-1.479 1.238-3.384 1.985-5.461 
                    1.985-4.697 0-8.509-3.812-8.509-8.508s3.812-8.508 
                    8.509-8.508c4.695 0 8.508 3.812 8.508 8.508 0 
                    2.078-.747 3.984-1.985 5.461l4.749 
                    4.75c.146.146.219.338.219.531 0 .587-.537.75-.75.75-.192 
                    0-.384-.073-.531-.22zm-5.461-13.53c-3.868 0-7.007 
                    3.14-7.007 7.007s3.139 7.007 7.007 7.007c3.866 0 
                    7.007-3.14 7.007-7.007s-3.141-7.007-7.007-7.007zm-.744 
                    6.26h-2.5c-.414 0-.75.336-.75.75s.336.75.75.75h2.5v2.5c0 
                    .414.336.75.75.75s.75-.336.75-.75v-2.5h2.5c.414 
                    0 .75-.336.75-.75s-.336-.75-.75-.75h-2.5v-2.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"/>
                  </svg>
                </span>
                <span class="config-text">{{ mapConfiguration?.zoom | hasValue }}</span>
              </div>
              <div class="config-item configure-map" data-bs-toggle="modal" data-bs-target="#showMap">
                <span class="icon">
                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M2.458 9.012c-.297.947-.458 1.955-.458 3 0 5.52 4.481 10 10 10 5.52 0 10-4.48 10-10 0-5.519-4.48-10-10-10-2.121 0-4.083.668-5.703 1.796l1.703 2.204h-6.58l1.935-6.012 1.718 2.223c1.958-1.389 4.346-2.211 6.927-2.211 6.623 0 12 5.377 12 12s-5.377 11.988-12 11.988-12-5.365-12-11.988c0-1.036.132-2.041.379-3h2.079zm10.35-3.012c.292.821.375 1.346 1.01 1.609.637.264 1.073-.052 1.854-.423l1.142 1.142c-.373.787-.687 1.218-.423 1.854.262.634.784.716 1.609 1.009v1.617c-.816.29-1.347.375-1.61 1.01-.264.636.052 1.071.424 1.853l-1.142 1.142c-.79-.375-1.219-.687-1.85-.424-.639.265-.723.793-1.014 1.611h-1.616c-.292-.821-.375-1.347-1.01-1.61-.637-.264-1.072.052-1.854.423l-1.142-1.142c.366-.771.689-1.212.423-1.854-.263-.635-.793-.719-1.609-1.009v-1.617c.817-.29 1.346-.373 1.609-1.009.264-.637-.051-1.07-.423-1.854l1.142-1.142c.788.374 1.218.687 1.854.423.635-.263.719-.792 1.01-1.609h1.616zm-.808 8c-1.105 0-2-.896-2-2 0-1.105.895-2.001 2-2.001 1.104 0 2 .896 2 2.001 0 1.104-.896 2-2 2z"/></svg>
                </span>
                <span class="configure-map-text">Configure map</span>
              </div>
            </div>

          </div>
        </div>
        <div class="btn-continue-container col-6">
          <button class="btn btn-continue" type="button" (click)="continue()">Continue</button>
        </div>
      </div>

      <div *ngIf="activeCard > 2" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="col-6">
              <span class="col-title row">Asset</span>
              <span class="col-subtitle row">AI UAV: {{isSelected(Configuration.AIDroneMap)}}</span>
              <span class="col-subtitle row">Feeders(33KV,11KV): {{isSelected(Configuration.Feeders)}}</span>
              <span class="col-subtitle row">Distribution Substation: {{isSelected(Configuration.DTs)}}</span>
              <span class="col-subtitle row">LT Poles: {{isSelected(Configuration.Poles)}}</span>
              <span class="col-subtitle row">Buildings: {{isSelected(Configuration.Buildings)}}</span>
              <span class="col-subtitle row">Meters: {{isSelected(Configuration.Meters)}}</span>

            </div>
            <div class="col-6">
              <span class="col-title row ">Operations</span>
              <span class="col-subtitle row ">Survey: {{isSelected(Configuration.Survey)}}</span>
              <span class="col-subtitle row ">Installation: {{isSelected(Configuration.Installation)}}</span>
              <span class="col-subtitle row ">Work order: {{isSelected(Configuration.WorkOrder)}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-3 item" [ngClass]="activeCard > 3 ? 'item-line' : ''">
      <div class="card-header">
        <diV class="num" [ngClass]="
            activeCard < 3
              ? 'card-number-gray'
              : activeCard > 3
              ? 'card-number-done'
              : ''
          ">3</diV>
        <div [ngClass]="activeCard < 3 ? 'title-gray' : ''">
          Translation
        </div>
        <div *ngIf="activeCard > 3" (click)="setActiveCard(3)">Edit</div>

      </div>
      <div *ngIf="activeCard === 3" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="container-fluid border-bottom">
              <table>
                <tr class="header-row">
                  <th>KEY</th>
                  <th>VALUE</th>
                </tr>
                <tr class="content-wrapper" (click)="selectTranslation(item)" *ngFor="let item of translationKeys"
                  data-bs-toggle="modal" data-bs-target="#changeTranslation">
                  <td>{{item.key}}</td>
                  <td>{{item.value}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="btn-continue-container col-6">
          <button class="btn btn-continue" type="button" (click)="continue()">Continue</button>
        </div>
      </div>
      <div *ngIf="activeCard > 3" class="filled-card">
        <div class="container card">
          <span class="col-title">Translations</span>
          <div class="row translations">
            <div class="col-6">
              <div class="col-subtitle row" *ngFor="let item of translationKeys">
                {{item.key}} : {{item.value}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form ngNativeValidate id="card4Form" (submit)="continue()" class="card-4"
      [ngClass]="activeCard > 4 ? 'item-line' : ''">
      <div class="card-header">
        <div class="num" [ngClass]="
            activeCard < 4
              ? 'card-number-gray'
              : activeCard > 4
              ? 'card-number-done'
              : ''
          ">4</div>
        <div [ngClass]="activeCard < 4 ? 'title-gray' : ''">
          Service Request Consent Configuration
        </div>
        <div *ngIf="activeCard > 4" (click)="setActiveCard(4)">Edit</div>
      </div>
      <div *ngIf="activeCard === 4">
        <div class="container card form-wrapper">
          <div class="row">
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="commission" name="commission" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Regulatory Commission</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="reform" name="reform" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Electricity Reform</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="regulation" name="regulation" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Network Regulation</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="management" name="management" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Electricity Management</label>
            </div>
               <label class="logo-label">Service Request Image Configuration</label>
        <div *ngIf=" serviceRequestImageUrl ==null ; else imageService" class="drag-drop col-12" appDragAndDrop
          (fileDropped)="onServiceFileDropped($event)">
          <input type="file" id="fileDropRef" name="serviceImage" #serviceImage
            accept="image/png, image/jpg, image/jpeg" (change)="serviceFileBrowserHandler($event)" />
          <div class="upload-img">
            <img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" />
          </div>
          <label for="fileDropRef">Drag and drop file here or <span class="browse">Browse</span> to
            upload</label>
        </div>
        <ng-template #imageService>
          <div class="pb-4">
            <img alt="Upload image" height="75" width="75" style="max-width: 100%" src="{{  serviceRequestImageUrl }}" />
            <span (click)="removeServiceImage()">x</span>
          </div>
        </ng-template>
          </div>

        </div>
        <div class="btn-continue-container col-6">
          <button class="btn btn-continue" form="card4Form">Continue</button>
        </div>
      </div>
      <div *ngIf="activeCard > 4" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="col-12">Regulatory Commission: {{commission}}</div>
            <div class="col-12">Electricity Reform: {{reform}}</div>
            <div class="col-12">Network Regulation: {{regulation}}</div>
            <div class="col-12">Electricity Management: {{management}}</div>
          </div>
        </div>
      </div>
    </form>
    <form ngNativeValidate id="card5Form" (submit)="continue()" class="card-5"
      [ngClass]="activeCard > 5 ? 'item-line' : ''">
      <div class="card-header">
        <div class="num" [ngClass]="
            activeCard < 5
              ? 'card-number-gray'
              : activeCard > 5
              ? 'card-number-done'
              : ''
          ">5</div>
        <div [ngClass]="activeCard < 5 ? 'title-gray' : ''">
          Bank Account Information
        </div>
        <div *ngIf="activeCard > 5" (click)="setActiveCard(5)">Edit</div>
      </div>
      <div *ngIf="activeCard === 5">
        <div class="container card form-wrapper">
          <div class="row">
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="bankName" name="bankName" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Bank Name</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="accountName" name="accountName" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Account Name</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="accountNumber" name="accountNumber" type="text" class="form-control" id="floatingInput2"
                placeholder=" ">
              <label for="floatingInput2">Account Number</label>
            </div>
          </div>

        </div>
        <div class="btn-continue-container col-6">
          <button class="btn btn-continue" form="card5Form">Continue</button>
        </div>
      </div>
      <div *ngIf="activeCard > 5" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="col-12">Bank Name: {{bankName}}</div>
            <div class="col-12">Account Name: {{accountName}}</div>
            <div class="col-12">Account Number: {{accountNumber}}</div>
          </div>
        </div>
      </div>
    </form>
    <form ngNativeValidate id="card6Form" (submit)="continue()" class="card-6">
      <div class="card-header">
        <div class="num" [ngClass]="
            activeCard < 6
              ? 'card-number-gray'
              : activeCard > 6
              ? 'card-number-done'
              : ''
          ">6</div>
        <div [ngClass]="activeCard < 6 ? 'title-gray' : ''">
          Contact Person </div>
        <div *ngIf="activeCard > 6" (click)="setActiveCard(6)">Edit</div>
      </div>
      <div *ngIf="activeCard === 6">
        <div class="container card form-wrapper">
          <div class="row">
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="firstName" name="firstName" type="text" class="form-control" id="floatingInput2"
                placeholder=" " required>
              <label for="floatingInput2">First Name</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="lastName" name="lastNamne" type="text" class="form-control" id="floatingInput2"
                placeholder=" " required>
              <label for="floatingInput2">Last Name</label>
            </div>
            <div class="col-12 form-item form-floating mb-3">
              <input [(ngModel)]="eMail" name="eMail" type="text" class="form-control" id="floatingInput2"
                placeholder=" " required>
              <label for="floatingInput2">E-Mail</label>
            </div>


          </div>

        </div>
        <div class="btn-continue-container col-6">
          <button class="btn btn-continue" form="card6Form">Continue</button>
        </div>
      </div>
      <div *ngIf="activeCard > 6" class="filled-card">
        <div class="container card">
          <div class="row">
            <div class="col-12">First Name: {{ firstName}}</div>
            <div class="col-12">Last Name: {{lastName}}</div>
            <div class="col-12">E-Mail: {{eMail}}</div>
          </div>
        </div>
      </div>
    </form>


  </div>

  <div class="modal fade" id="changeTranslation" tabindex="-1" aria-labelledby="changeTranslationTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Change translation</h5>
          <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            Cancel
          </button>
        </div>
        <form id="addForm" class="form-wrapper" ngNativeValidate (submit)="saveTranslation()">
          <div class="modal-body">
            <div class="form-item form-floating mb-3">
              <input name="name" type="text" [(ngModel)]="selectedTranslation.key" [disabled]="true"
                class="form-control" required placeholder=" " id="selectedTtranslationKey"/>
              <label for="selectedTtranslationKey">Key</label>
            </div>
            <div class="form-item form-floating mb-3">
              <input name="code" type="text" [(ngModel)]="selectedTranslation.value" class="form-control" required
                placeholder=" " id="selectedTtranslationVal"/>
              <label for="selectedTtranslationVal">Value</label>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" form="addForm">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <app-map-setup [setMapVisibility]="isMapVisible" 
                        [longitude]="18.2811944"
                        [latitude]="9.1021111"
                        [zoom]="4"
                        (mapConfigurationSaved)="onMapConfigurationSaved($event)">
        </app-map-setup>
        <button #closeMapModalBtn 
                type="button" 
                class="btn btn-secondary d-none" 
                data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>